export default __webpack_public_path__ + "static/media/hrb-logo.95cbc973.svg";